/** Estimate use groups, flattened to the shape reports and charts read. */
import { EstimateUseGroup, ReportUseGroup } from "../../interfaces/EstimateUseGroup";
import { FloorGroup } from "../../interfaces/AreaSheet";

export const transformUseGroups = (
  useGroups: EstimateUseGroup[],
  floorGroups: FloorGroup[],
  useGroupsCategoryDictionary: Record<string, string> = {}
): ReportUseGroup[] => {
  return useGroups.map((useGroup) => {
    const denominators = Object.values(useGroup.totals_cost_denominators || {}).reduce(
      (acc, denom) => {
        acc[`${denom.name}_count`] = denom.total;
        return acc;
      },
      {} as { [name: string]: number }
    );
    const floorGroup = floorGroups.find((fg) => fg.id === useGroup.floor_group);
    const floorGroupLabel = floorGroup ? floorGroup.label : "unassigned";
    return {
      order: useGroup.order,
      name: useGroup.label || useGroup.use_group,
      parent_use_group: useGroup.use_group,
      floor_group: floorGroupLabel,
      costOfTradesSubtotal: useGroup.costOfTradesSubtotal,
      gsf: useGroup.gsf,
      nsf: useGroup.nsf,
      unit_count: useGroup.unit_count,
      unit_cost_label: useGroup.unit_cost_label || "unit",
      ...denominators,
      room_area: useGroup.room_area,
      room_count: useGroup.room_count,
      use_group: useGroup.use_group,
      exclude_area: useGroup.exclude_area,
      id: useGroup.id,
      use_group_id: useGroup.use_group_id,
      category: useGroupsCategoryDictionary[useGroup.use_group_id] || "",
    };
  });
};
